import React from 'react';
import Tab from 'src/components/tab';
import Title from 'src/components/title';
import DashboardLayout from 'src/containers/dashboard-layout';
import AccountInfoTab from '../settings/AccountInfoTab';
import BusinessInfoTab from '../settings/BusinessInfoTab';
import CustomerAppTab from '../settings/CustomerAppTab';
import KitchenDisplayStatus from '../settings/KitchenDisplayStatus';
import LoyaltyPoints from '../settings/LoyaltyPoints';
import PasswordTab from '../settings/PasswordTab';
import GetStarted from './GetStarted';

interface IProps {}

const Help: React.FC<IProps> = ({}) => {
  const [activeTabIndex, setActiveIndex] = React.useState(0);

  const tabData = [
    {
      id: 0,
      label: 'Getting Started',
    },
    {
      id: 1,
      label: 'Sales',
    },
    {
      id: 2,
      label: 'Items',
    },
    {
      id: 3,
      label: 'Advanced Inventory',
    },
    {
      id: 4,
      label: 'Employees',
    },
    {
      id: 5,
      label: 'Customers',
    },
    {
      id: 6,
      label: 'Dashboard',
    },
    {
      id: 7,
      label: 'Settings',
    },
    {
      id: 8,
      label: 'Hardware',
    },
    {
      id: 9,
      label: 'Payments',
    },
  ];
  return (
    <div className="grid grid-cols-12 gap-9 mt-6 text-black">
      <div className="md:col-span-4 col-span-12">
        <Tab
          activeIndex={activeTabIndex}
          setActiveIndex={setActiveIndex}
          tabData={tabData}
        />
      </div>
      <div className="md:col-span-8 col-span-12 mb-10">
        {activeTabIndex === 0 ? (
          <GetStarted />
        ) : activeTabIndex === 1 ? (
          <GetStarted />
        ) : activeTabIndex === 2 ? (
          <GetStarted />
        ) : activeTabIndex === 3 ? (
          <GetStarted />
        ) : activeTabIndex === 4 ? (
          <GetStarted />
        ) : activeTabIndex === 5 ? (
          <GetStarted />
        ) : activeTabIndex === 6 ? (
          <GetStarted />
        ) : activeTabIndex === 7 ? (
          <GetStarted />
        ) : activeTabIndex === 8 ? (
          <GetStarted />
        ) : activeTabIndex === 9 ? (
          <GetStarted />
        ) : null}
      </div>
    </div>
  );
};

export default React.memo(Help);
